export default (() => {
  var cookienotification = window.getCookie("cookienotification");
  if (!cookienotification) {
    $('.js-cookie-notification').removeClass('cookie-notification-closed')
    $('.js-cookie-notification-close').click(function () {
      $('.js-cookie-notification').addClass('cookie-notification-closed')
      document.cookie = "cookienotification=false; path=/;";
    })
  }
})()
